import $ from "jquery";
import * as GC from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";

export default function standart() {}

export async function fillDetail() {
  $("#d-algemeen-naam").html(
    window.$catalog_planning_pattern_selectedRow.algemeenNaam
  );
  $("#d-algemeen-naam-tooltip").html(
    window.$catalog_planning_pattern_selectedRow.algemeenNaam
  );
  $("#d-algemeen-code").html(
    window.$catalog_planning_pattern_selectedRow.algemeenCode
  );
  $("#d-algemeen-omschrijving").html(
    window.$catalog_planning_pattern_selectedRow.omschrijving
  );
  $("#d-algemeen-omschrijving-tooltip").html(
    window.$catalog_planning_pattern_selectedRow.omschrijving
  );
  $("#d-algemeen-frequentie").html(
    window.$catalog_planning_pattern_selectedRow.frequentie
  );
  $("#d-algemeen-starten").html(
    window.$catalog_planning_pattern_selectedRow.startenna
  );
  $("#d-algemeen-aantal").html(
    window.$catalog_planning_pattern_selectedRow.maxaantal
  );
  $("#d-algemeen-cyclus").html(
    window.$catalog_planning_pattern_selectedRow.cyclus
  );

  if (window.$catalog_planning_pattern_selectedRow.isActive)
    $("#algemeen_active").attr("checked", "checked");
  else $("#algemeen_active").removeAttr("checked");

  /**
   * * Edit side
   */
  $("#e-algemeen-naam").val(
    window.$catalog_planning_pattern_selectedRow.algemeenNaam
  );
  $("#e-algemeen-code").val(
    window.$catalog_planning_pattern_selectedRow.algemeenCode
  );
  $("#e-algemeen-omschrijving").val(
    window.$catalog_planning_pattern_selectedRow.omschrijving
  );
  $("#e-algemeen-frequentie").val(
    window.$catalog_planning_pattern_selectedRow.frequentie
  );
  $("#e-algemeen-starten").val(
    window.$catalog_planning_pattern_selectedRow.startenna
  );
  $("#e-algemeen-aantal").val(
    window.$catalog_planning_pattern_selectedRow.maxaantal
  );
  $("#e-algemeen-cyclus").val(
    window.$catalog_planning_pattern_selectedRow.cyclus
  );

  if (window.$catalog_planning_pattern_selectedRow.isActive)
    $("#e-algemeen_active").attr("checked", "checked");
  else $("#e-algemeen_active").removeAttr("checked");

  $("#e-identification").val(
    window.$catalog_planning_pattern_selectedRow.identification
  );
}

export function GetColumnProperties(callType) {
  omnimap
    .GetColumnPropertiesAction(window.$catalog_management_units_token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesCallBack(result, callType);
      // fillDetail();
    });
}
export function GetColumnPropertiesForModel(
  model,
  pageNr,
  pageSize,
  callType,
  itemId,
  token
) {
  omnimap
    .OmnimapPost(model, pageNr, pageSize, token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesForModelCallBack(
        result,
        itemId,
        callType
      );
    })
    .catch((error) => {
      console.log(error);
    });
}

export const rowsHandleDelete = () => {
  // 1. bu kayıtın relationlarını getir.
  // 2. tüm relationlarını sil.
  // 3. sonra kayıtı sil.
  $("#cover-spin").show(0);
  window.$catalog_planning_pattern_selectedIds.forEach(async (element) => {
    let realtions = await omnimap.GetRelationAction(
      element,
      1,
      30,
      window.$catalog_management_units_token
    );

    if (realtions.data !== undefined) {
      await realtions.data.forEach(async (relation) => {
        let result = await omnimap
          .DeleteRelationAction(
            relation.identification,
            window.$catalog_management_units_token
          )
          .catch((error) => {
            console.log(error);
          });
        var test = "";
      });
    }

    GC.sleep(2000).then(async () => {
      let result = await omnimap
        .Delete(element, window.$catalog_management_units_token)
        .catch((error) => {
          console.log(error);
        });

      CallBackFunctions.RowsDeletedCallBack(
        window.$catalog_management_units_token
      );
    });
  });
};

export const GetMedia = (rowId) => {
  return new Promise(function (resolve, reject) {
    fetch(
      `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/media/${rowId}/content`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: "Bearer " + window.$catalog_management_units_token,
          tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
          organisation_identification:
            process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
        },
      }
    )
      .then((response) => response.blob())
      .then((images) => {
        // Then create a local URL for that image and print it
        var outside = URL.createObjectURL(images);
        // this.setState({ gettingMedia: outside });
        resolve(outside);
      })
      .catch((err) => alert(err));
  });
};
